// Mock data for Desi Fusion Indian Street Food

export const businessInfo = {
  name: "Desi Fusion",
  tagline: "Indian Street Food",
  description: "Authentic Indian street food served fresh from our mobile food truck. We bring the vibrant flavors of India to your events, celebrations, and gatherings.",
  email: "desifusion2026@gmail.com",
  phone: "+44 7448262825/+44 7448275942", // 
  slogan: "SPICE IT, LOVE IT, DESI IT",
  logo: "https://i.ibb.co/Q3wvPvLN/New-Logo-Desi-Fusion.png",
  truckImage: "https://i.ibb.co/pBwN8yxP/Trailer-Photo.png"
};

export const menuItems = [
  {
    id: 1,
    category: "Mains",
    name: "Royal Spice Biryani",
    description: "Aromatic basmati rice layered with tender chicken, slow-cooked with bold spices and herbs for a rich, satisfying flavor",
    image: "https://images.unsplash.com/photo-1631515243349-e0cb75fb8d3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxiaXJ5YW5pfGVufDB8fHx8MTc3NTY1NjIzMXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    category: "Mains",
    name: "Loaded Butter Chicken Bowl",
    description: "Creamy, buttery chicken in a smooth tomato gravy, served with fluffy rice—comfort food done right",
    image: "https://violarecipes.com/wp-content/uploads/2025/04/butter-chicken-rice-finish-serve.jpg"
  },
  {
    id: 3,
    category: "Samosas",
    name: "Samosa Chaat Fusion",
    description: "Crunchy samosas crushed and layered with tangy chutneys, yogurt, green chutney and spices—a perfect balance of sweet, spicy, and savory",
    image: "https://i.pinimg.com/originals/bb/d1/eb/bbd1ebb7e4292e0d31a2fbbfe45c29fb.jpg"
  },
  {
    id: 4,
    category: "Samosas",
    name: "Cheesy Pizza Samosa",
    description: "3 Crispy samosa filled with gooey cheese, herbs, and pizza-style flavours—a fun desi twist",
    image: "https://www.unileverfoodsolutions.pk/dam/global-ufs/mcos/meps/pakistan/calcmenu/recipes/PK-recipes/pizza-samosa/pizza-samosa-main-header-1260x709.jpg"
  },
  {
    id: 5,
    category: "Samosas",
    name: "Punjabi Samosas",
    description: "3 Classic crispy samosas stuffed with a savory filling—simple, satisfying",
    image: "https://www.cubesnjuliennes.com/wp-content/uploads/2020/08/Best-Indian-Punjabi-Samosa-Recipe.jpg"
  },
  {
    id: 6,
    category: "Sides",
    name: "Fully Loaded Street Chips",
    description: "Crispy chips topped with cheesy, saucy, spicy goodness—big flavor in every bite",
    image: "https://realfood.tesco.com/media/images/1400x919-TunaMeltLoadedChips-bc362892-6def-4ade-8a0d-416d38b12ef7-0-1400x919.jpg"
  },
  {
    id: 7,
    category: "Drinks",
    name: "Refresh Soft Drinks",
    description: "A selection of chilled soft drinks to keep things cool and refreshing",
    image: "https://wallpaperaccess.com/full/6460011.jpg"
  },
  {
    id: 8,
    category: "Karak Beverage",
    name: "Karak Masala Chai",
    description: "Strong, spiced Indian tea brewed with milk—bold, smooth, and energizing",
    image: "https://images.unsplash.com/photo-1619581073186-5b4ae1b0caad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxtYXNhbGElMjBjaGFpfGVufDB8fHx8MTc3NTY1NjIyMnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    category: "Karak Beverage",
    name: "Smooth Brew Coffee",
    description: "Classic cheesecake with a graham cracker crust",
    image: "https://tse2.mm.bing.net/th/id/OIP.JRHVAngJ44q2gDs7PyCSOwHaEH?w=331&h=184&c=7&r=0&o=7&dpr=1.5&pid=1.7&rm=3"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.pexels.com/photos/7625056/pexels-photo-7625056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Butter Chicken Bowl"
  },
  {
    id: 2,
    url: "https://cdn.loveandlemons.com/wp-content/uploads/2022/06/how-to-make-lemonade.jpg",
    alt: "Summary Lemonade"
  },
  {
    id: 3,
    url: "https://images.timesnownews.com/thumb/msid-118295420,thumbsize-37752,width-1280,height-720,resizemode-75/118295420.jpg",
    alt: "Loaded Fries"
  },
  {
    id: 4,
    url: "https://janeskitchenmiracles.com/wp-content/uploads/Spicy-Italian-Panini-recipe.jpg",
    alt: "Panini"
  },
  {
    id: 5,
    url: "https://tse1.mm.bing.net/th/id/OIP.soLkiyYwgfd-pg47zqbW_gHaLH?rs=1&pid=ImgDetMain&o=7&rm=3",
    alt: "Masala Chai"
  },
  {
    id: 6,
    url: "https://megachickenrecipes.com/wp-content/uploads/2022/08/Chicken-fry-piece-biryani-recipe2-768x432.jpg",
    alt: "Chicken Biryani"
  }
];

export const services = [
  {
    id: 1,
    title: "Event Catering",
    description: "Book our vibrant food truck for your weddings, corporate events, birthday parties, and special celebrations. We bring authentic Indian street food right to your venue.",
    icon: "PartyPopper"
  },
  {
    id: 2,
    title: "Festival & Fairs",
    description: "Find us at local festivals, fairs, and community events across the region. Follow our social media for location updates and event schedules.",
    icon: "Calendar"
  },
  {
    id: 3,
    title: "Private Bookings",
    description: "Looking for something unique? We offer customized menu options for private bookings and special dietary requirements. Contact us to discuss your needs.",
    icon: "Star"
  }
];
